/**
 * Product search frontend script
 */
function openWidget(handle) {

  // Check for an active widget
  const active = document.querySelector('.bnd-search-widget')
  if(active) return

  // Create the element
  const widget = document.createElement('div')
  widget.classList.add('bnd-search-widget')
  widget.innerHTML = `
    <form action="/?post_type=product" method="get">
      <input aria-label="search input field" type="text" name="s" value="" placeholder="Search" />
      <input type="hidden" name="post_type" value="product" />
      <button text="search" type="submit">
        <svg alt="search button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M448 272C448 174.8 369.2 96 272 96C174.8 96 96 174.8 96 272C96 369.2 174.8 448 272 448C369.2 448 448 369.2 448 272zM407.3 430C371 461.2 323.7 480 272 480C157.1 480 64 386.9 64 272C64 157.1 157.1 64 272 64C386.9 64 480 157.1 480 272C480 323.7 461.2 371 430 407.3L571.3 548.7C577.5 554.9 577.5 565.1 571.3 571.3C565.1 577.5 554.9 577.5 548.7 571.3L407.3 430z"/></svg>
      </button>
    </form>
  `

  // Set default styles
  widget.style.overflow = 'visible'

  // Ignore widget clicks
  widget.onclick = (event) => {
    event.stopPropagation()
  }

  // Append to the body
  document.body.appendChild(widget)

  // Calculate search widget left position to center
  const calculateLeft = () => {

    const active = document.querySelector('.bnd-search-widget')
    if(!active) return

    const rect = active.getBoundingClientRect()
    const width = rect.width
    const screenWidth = window.innerWidth

    active.style.left = Math.max((screenWidth / 2) - (width / 2), 0) + 'px'
  }
  
  calculateLeft()

  window.addEventListener('resize', () => {
    calculateLeft()
  })
}

window.addEventListener('DOMContentLoaded', () => {

  // Put the widget on the page
  openWidget()

  // Wire the listener to search
  const searchHandles = document.querySelectorAll('.wp-block-bnd-blocks-bnd-product-search')
  if(!searchHandles || searchHandles.length < 1) return

  for(const handle of searchHandles) {
    handle.onclick = (event) => {

      event.stopPropagation()

      const active = document.querySelector('.bnd-search-widget')
      active.classList.remove('close')
      active.classList.add('show')

      // focus on the input
      const searchHandle = document.querySelector('.bnd-search-widget input[name=s]')
      if(searchHandle) {
        searchHandle.focus()
      }
    }
  }

  // Wire the close on document body click
  document.body.addEventListener('click', () => {
    const active = document.querySelector('.bnd-search-widget')
    
    if(active && active.classList.contains('show')) {
      active.classList.remove('show')
      active.classList.add('close')   
    }
  })
})